export const trainingStartName = 'trainingStartDate'
export const programStartName = 'programStartDate'
export const schoolYearEndName = 'schoolYearEndDate'
